import sortByDateProp from '../../../lib/sortByDateProp';
import { createSelector } from 'reselect';

export const autoselectedPhoneSelector = (chatHistory, activeLeadContacts) =>
  createSelector(chatHistory, activeLeadContacts, (chatHistory, activeLeadContacts) => {
    const contacts = activeLeadContacts || [];
    const outgoingChats = (chatHistory || [])
      .filter((n) => n.outgoing === '1')
      .filter((n) => n.platform_id !== '17')
      .filter((n) => ['texts', 'phone_calls'].includes(n.type))
      .sort(sortByDateProp('creationDatetime'));

    let contactDetail;
    outgoingChats.find((n) => {
      let contactId = n.contact_id;
      let contact = contacts.find((n) => n.id === contactId);
      if (!contact) {
        return false;
      }
      const detail = (contact.details || []).find((n) => n.detail_type_id === '1');
      if (!detail) {
        return false;
      }
      contactDetail = detail;
      return true;
    });

    if (contactDetail) {
      return contactDetail;
    }

    contacts.find((contact) => {
      const detail = (contact.details || []).find((n) => n.detail_type_id === '1');
      if (detail) {
        contactDetail = detail;
        return true;
      }
      return false;
    });

    return contactDetail;
  });

export default autoselectedPhoneSelector;
